import BuildIdLogo from "./../assets/images/BuildIdLogo.png";
import StoreIcon from "./../assets/images/store-icon.png";
import playStore from "./../assets/images/playStore.png";
import appleStore from "./../assets/images/appleStore.png";
//Home Page Graphics
import map from "./../assets/images/Sites/maps.png";
import connect from "./../assets/images/Sites/connect.png";
import site from "./../assets/images/Sites/sites.png";
// import site from "./../assets/images/site.png";
import safetytickets from "./../assets/images/Safety-tickets.png";
// import safetytickets from "./../assets/images/safety-tickets.jpg";
import resume from "./../assets/images/Resume.png";
// import resume from "./../assets/images/construction-resume.jpg";
import EarnBuilderBucks from "./../assets/images/BuilderBucks.png";
// import EarnBuilderBucks from "./../assets/images/earn-builderbucks.jpg";
import MoreFeatures from "./../assets/images/more-features.png";
import "../assets/css/Home.css";
import { useDocumentMetaData } from "../common/components/useDocumentMetaData";

export default function Home() {
  useDocumentMetaData({
    title: "My Builder ID - Showcase Your Builder Portfolio",
    description:
      "Create and showcase your builder portfolio, connect with clients, and grow your digital identity online.",
    keywords:
      "builder portfolio, digital identity, showcase projects, construction, client connections,  Community, Sites, Reward Store, Timesheet, Resume Builder, Personal Expenses, Tickets, Montages, Builder Network, Carpool, Job Postings, Buy Sell, Companies, Manufactures, Products, Trades, Profile, Chat, Work Buddy, Actions, Change Tracker, Coaching, Communicator, Equipment Inspection, Expenses, Inspection, Quality Control, Safety Incident, Safety Observation, Site Activity Report, Site, Estimates, Site Filing, Support Request, Take 5, Crew Timesheet, Videos, Work Package",
    canonical: "https://mybuilderid.com",
    robots: "index, follow",
    author: "MyBuilderID Team",
    ogTitle: "Showcase Your Builder Portfolio with MyBuilderID",
    ogDescription:
      "Build your online presence, showcase projects, and connect with clients.",
    ogImage:
      "https://mybuilderid.com/static/media/logo01.a7fc7fdc78443fa49049.png",
    ogUrl: "https://mybuilderid.com",
    twitterCard: "summary_large_image",
    twitterTitle: "MyBuilderID - Showcase Your Builder Portfolio",
    twitterDescription:
      "Showcase projects, build your online identity, and grow your network.",
    twitterImage:
      "https://mybuilderid.com/static/media/logo01.a7fc7fdc78443fa49049.png",
  });

  return (
    <>
      <section className="heading-section bulk-sms padding-top padding-bottom homepage-altcol-1">
        <div className="container">
          <div className="home-container row flex-wrap-reverse align-items-center">
            {/* <div className="col-lg-7"> */}
            <div
              className="bulk-content text-center text-sm-left wow fadeIn"
              data-wow-delay=".3s"
            >
              <div className="first-section-logo">
                <div className="hero-title">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      margin: "6vh 0 6vh 0",
                    }}
                  >
                    <div className="store-icon">
                      <img
                        src={StoreIcon}
                        alt="BuildId Marketing Logo - Be part of the Builder Community"
                        style={{ borderRadius: "8px" }}
                      />
                    </div>
                    <h2 style={{ margin: "auto 24px auto 24px" }}>
                      Be part of the Builder Community{" "}
                    </h2>
                  </div>

                  <h6 className="description">
                    BuildID is a tool for tradespeople and others working in the
                    construction industry that take pride in building the
                    structures that shape our world. We want to create a
                    construction community that empowers and rewards all
                    members.{" "}
                  </h6>
                </div>
              </div>
              <div className="download-btn">
                <a
                  href="https://mybuilderid.onelink.me/hhPN/androidweb"
                  className="store-icon"
                >
                  <img
                    src={playStore}
                    alt="Download BuildId app on Google Play Store"
                  />
                </a>
                <a
                  href="https://mybuilderid.onelink.me/hhPN/appleweb"
                  className="store-icon"
                >
                  <img
                    src={appleStore}
                    alt="Download BuildId app on Apple App Store"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bulk-sms padding-top padding-bottom theme-dark homepage-altcol-1">
        <div
          /*className="container"*/ style={{
            textAlign: "center",
            width: "100%",
            padding: "1vw",
          }}
        >
          <div className="site-card-container">
            <div className="site-card">
              <img
                src={map}
                alt="Construction project locations map - BuildId"
              />
              <div className="site-card-text">
                <h3>Maps</h3>
                <p>
                  View work sites and construction projects in your area, or
                  anywhere in the world! See where fellow builders are actively
                  engaged and showcase your own past and current work sites and
                  projects.
                </p>
              </div>
            </div>

            <div className="site-card">
              <img
                src={connect}
                alt="Connect with construction professionals - BuildId"
              />
              <div className="site-card-text">
                <h3>Connect</h3>
                <p>
                  Stay connected with every builder you encounter, from trades
                  on your work site, to builders you worked with multiple
                  projects ago. Strengthen your professional relationships, gain
                  expert skills, and streamline communication, as you grow your
                  network to include tradespeople from all throughout your
                  career.
                </p>
              </div>
            </div>

            <div className="site-card">
              <img src={site} alt="Construction site showcase - BuildId" />
              <div className="site-card-text">
                <h3>Sites</h3>
                <p>
                  Sites are the physical locations where construction projects
                  are taking place or have been completed. A construction site
                  may have multiple projects recorded on it, past or present.
                  There's so much to discover on every site you find!
                </p>
              </div>
            </div>
          </div>

          {/* <div className="row flex-wrap-reverse">
            <div className="col-lg-4 col-md-4 col-sm-12 ">


            </div>

            <div className="col-lg-4 col-md-4 col-sm-12">

              <img src={site} className="explore-img" alt="bulk" />
            </div>

            <div className="col-lg-4 col-md-4 col-sm-12">

              <img src={connect} className="explore-img" alt="bulk" />
            </div>
          </div> */}
        </div>
      </section>

      <section className="bulk-sms padding-top padding-bottom homepage-altcol-2">
        <div className="container">
          <div className="row flex-wrap-reverse align-items-center">
            <div className="col-lg-6">
              <div className="bulk-thumb wow slideInRight">
                <img
                  src={safetytickets}
                  alt="Add and share your safety tickets - BuildId"
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="bulk-content text-center text-sm-left wow fadeIn"
                data-wow-delay=".3s"
              >
                <h2 className="title">Add and share your safety tickets</h2>
                <p style={{ paddingBottom: "18px" }}>
                  Keep your managers and others around you updated by sharing
                  your tickets.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bulk-sms padding-top padding-bottom homepage-altcol-1">
        <div className="container">
          <div className="row flex-wrap-reverse align-items-center">
            <div className="col-lg-6">
              <div
                className="bulk-content text-center text-sm-left wow fadeIn"
                data-wow-delay=".3s"
              >
                <h2 className="title">Earn BuilderBucks </h2>
                <p style={{ paddingBottom: "18px" }}>
                  Collect BuilderBucks by adding information to BuildID, and
                  redeem them for rewards in our store.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="bulk-thumb wow slideInRight">
                <img
                  src={EarnBuilderBucks}
                  alt="Earn BuilderBucks rewards - BuildId"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bulk-sms padding-top padding-bottom homepage-altcol-2">
        <div className="container">
          <div className="row flex-wrap-reverse align-items-center">
            <div className="col-lg-6">
              <div className="bulk-thumb wow slideInRight">
                <img
                  src={resume}
                  alt="Generate professional construction resumes - BuildId"
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="bulk-content text-center text-sm-left wow fadeIn"
                data-wow-delay=".3s"
              >
                <h2 className="title">Generate professional-looking resumes</h2>
                <p style={{ paddingBottom: "18px" }}>
                  Add your companies, projects, and education to your profile –
                  then export it as a PDF resume.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bulk-sms padding-top padding-bottom theme-dark homepage-altcol-1">
        <div className="container">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div style={{ flex: 1, paddingRight: "20px" }}>
              <h2
                className="title dark-theme-title"
                style={{ marginBottom: "30px" }}
              >
                More great features
              </h2>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ flex: 1 }}>
                  <li style={{ listStyle: "none" }}>
                    <i className="fa fa-check-circle features-list-icon"></i>
                    Chat
                  </li>
                  <li style={{ listStyle: "none" }}>
                    <i className="fa fa-check-circle features-list-icon"></i>See
                    project updates
                  </li>
                  <li style={{ listStyle: "none" }}>
                    <i className="fa fa-check-circle features-list-icon"></i>
                    Ride share
                  </li>
                  <li style={{ listStyle: "none" }}>
                    <i className="fa fa-check-circle features-list-icon"></i>
                    Timesheets
                  </li>
                </div>
                <div style={{ flex: 1 }}>
                  <li style={{ listStyle: "none" }}>
                    <i className="fa fa-check-circle features-list-icon"></i>
                    Expense tracking
                  </li>
                  <li style={{ listStyle: "none" }}>
                    <i className="fa fa-check-circle features-list-icon"></i>
                    Montage creator
                  </li>
                  <li style={{ listStyle: "none" }}>
                    <i className="fa fa-check-circle features-list-icon"></i>
                    Review Products
                  </li>
                  <li style={{ listStyle: "none" }}>
                    <i className="fa fa-check-circle features-list-icon"></i>
                    Network with tradespeople
                  </li>
                </div>
              </div>
            </div>
            <div>
              <div className="bulk-thumb wow slideInRight">
                <img src={MoreFeatures} alt="bulk" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
